module.exports = __webpack_public_path__ + "img/poster.b354f835.jpg";